import { render, staticRenderFns } from "./SustainabilityDashboard.vue?vue&type=template&id=d6c682fa&scoped=true&"
import script from "./SustainabilityDashboard.vue?vue&type=script&lang=js&"
export * from "./SustainabilityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SustainabilityDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c682fa",
  null
  
)

export default component.exports